export default __webpack_public_path__ + "static/media/pyposition_63b_big.82ea299b.png";